import gsap from 'gsap';
import Sniffer from 'sniffer';
import imagesLoaded from 'imagesloaded';

export default class Loader {
  constructor() {
    this.body = document.querySelector('body');
    this.main = document.querySelector('.a-main');
    this.footer = document.querySelector('.p-home .s-footer');

    this.loader = {
      logo: document.querySelector('.a-loader-logo'),
      progress: document.querySelector('.a-loader-progress'),
      indicator: document.querySelector('.a-loader-indicator'),
      container: document.querySelector('.a-loader-container'),
    };

    this.logo = document.querySelector('.a-logo');

    this.slides = {
      el: document.querySelector('.s-slides'),
      nav: document.querySelector('.s-slides-nav'),
      mask: document.querySelectorAll('.s-slides-mask'),
      heading: document.querySelectorAll('.s-slides-heading'),
      paragraphs: document.querySelectorAll('.s-slides-heading p'),
      images: document.querySelectorAll('.s-slides-image'),
    };

    this.bio = document.querySelector('.s-bio');

    this.menu = {
      login: document.querySelector('.a-menu-login'),
      trigger: document.querySelector('.a-menu-trigger'),
    };

    if (this.slides.el) {
      this.lines = this.slides.heading[0].querySelectorAll('.f-xl-line');
    } else {
      this.title = document.querySelector('.s-header-title');
      this.lines = document.querySelectorAll('.s-header-head .f-xl-line');
    }

    if (Sniffer.isPhone) {
      this.elY = 0.208;
    } else {
      this.elY = 0.104;
    }

    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
  }

  setIntro = () => {
    if (!Sniffer.isPhone) {
      gsap.set(this.menu.trigger, {
        opacity: 0,
        pointerEvents: 'none',
      });
    }

    gsap.set([this.logo, this.menu.login, this.slides.nav], {
      y: -Math.round(this.ww * this.elY),
    });

    gsap.set(this.lines, {
      y: this.wh,
    });

    gsap.set(this.slides.paragraphs, {
      autoAlpha: 0,
    });

    gsap.set(this.slides.mask, {
      delay: 0.2,
      opacity: 0.6,
      y: -Math.round(this.ww * 0.055),
      width: Math.round(this.ww * 0.104),
      height: Math.round(this.ww * 0.078),
    });

    gsap.set(this.slides.mask[0], {
      delay: 0.2,
      x: Math.round(this.ww * 0.396),
    });

    gsap.set(this.slides.mask[1], {
      delay: 0.2,
      x: Math.round(this.ww * 0.5),
    });

    gsap.set(this.slides.mask[2], {
      delay: 0.2,
      x: Math.round(this.ww * 0.604),
    });

    gsap.set(this.slides.mask[3], {
      delay: 0.2,
      x: Math.round(this.ww * 0.292),
    });
  }

  showIntro = () => {
    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
      },
      onComplete: () => {
        this.body.classList.remove('is-loading');
        this.loader.indicator.remove();
        this.resetLoader();
      },
    });

    if (Sniffer.isPhone) {
      this.m0x = Math.round(this.ww * 0.168);
      this.m0y = -Math.round(this.ww / 2);

      this.m1x = Math.round(this.ww * 0.898);
      this.m1y = -Math.round(this.ww * 0.1);

      this.m2x = Math.round(this.ww + this.ww * 0.5);
      this.m2y = -Math.round(this.ww * 0.1);

      this.m3x = -Math.round(this.ww * 0.333);
      this.m3y = -Math.round(this.ww * 0.5);

      this.lw = Math.round(this.ww * 0.66);
      this.lh = Math.round(this.ww);

      this.sw = Math.round(this.ww * 0.43);
      this.sh = Math.round(this.ww * 0.6);

      this.mw = Math.round(this.ww * 0.43);
      this.mh = Math.round(this.ww * 0.6);
    } else {
      this.m0x = Math.round(this.ww * 0.336);
      this.m0y = -Math.round(this.ww * 0);

      this.m1x = Math.round(this.ww * 0.813);
      this.m1y = Math.round(this.ww * 0.08);

      this.m2x = Math.round(this.ww + this.ww * 0.203);
      this.m2y = Math.round(this.ww * 0.085);

      this.m3x = 0;
      this.m3y = -Math.round(this.ww * 0.105);

      this.lw = Math.round(this.ww * 0.397);
      this.lh = Math.round(this.ww * 0.312);

      this.sw = Math.round(this.ww * 0.187);
      this.sh = Math.round(this.ww * 0.197);

      this.mw = Math.round(this.ww * 0.258);
      this.mh = Math.round(this.ww * 0.245);
    }

    tl
      .to(this.loader.logo, {
        opacity: 1,
        duration: 0.5,
      }, 0)

      .to(this.loader.logo, {
        opacity: 0,
        y: this.wh,
      }, 0.5)

      .to(this.loader.container, {
        y: -Math.round(this.wh),
      }, 0.5)

      .to(this.loader.progress, {
        xPercent: 100,
      }, 0.7)

      .to(this.loader.indicator, {
        y: Math.round(this.ww * this.elY),
      }, 1.5)

      .to([this.menu.login, this.logo], {
        y: 0,
        clearProps: 'all',
      }, 1.5)

      .to(this.slides.mask[0], {
        opacity: 1,
        x: this.m0x,
        y: this.m0y,
        width: this.lw,
        height: this.lh,
      }, 1.5)

      .to(this.slides.mask[1], {
        opacity: 1,
        x: this.m1x,
        y: this.m1y,
        width: this.sw,
        height: this.sh,
      }, 1.5)

      .to(this.slides.mask[2], {
        opacity: 1,
        x: this.m2x,
        y: this.m2y,
        width: this.sw,
        height: this.sh,
      }, 1.5)

      .to(this.slides.mask[3], {
        opacity: 1,
        x: this.m3x,
        y: this.m3y,
        width: this.mw,
        height: this.mh,
      }, 1.5)

      .to(this.slides.nav, {
        y: 0,
        clearProps: 'all',
      }, 1.5)

      .fromTo([this.slides.images[1], this.slides.images[2], this.slides.images[3]], {
        opacity: 1,
      }, {
        opacity: 0.35,
      }, 1.5)

      .to(this.lines, {
        y: 0,
        duration: 2,
        stagger: 0.09,
        clearProps: 'all',
      }, 1.5)

      .to(this.slides.paragraphs[0], {
        autoAlpha: 1,
        duration: 1,
      }, 2.8)

      .fromTo(this.footer, {
        opacity: 0,
      }, {
        opacity: 1,
      }, 2);
  }

  resetLoader = () => {
    gsap.set(this.loader.container, {
      y: 0,
      yPercent: 100,
    });

    if (this.loader.indicator) {
      this.loader.indicator.remove();
    }
  }

  setLoader = () => {
    this.loader.indicator.remove();

    gsap.set(this.menu.login, {
      opacity: 0,
      pointerEvents: 'none',
    });

    if (this.bio) return;

    gsap.set(this.title, {
      opacity: 0,
      y: -Math.round(this.ww * this.elY),
    }, 0);

    gsap.set(this.lines, {
      y: this.wh,
    });
  }

  showLoader = () => {
    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
      },
      onComplete: () => {
        this.body.classList.remove('is-loading');
        this.resetLoader();
      },
    });

    tl
      .to(this.loader.logo, {
        opacity: 1,
        duration: 0.5,
      }, 0)

      .to(this.loader.container, {
        y: -Math.round(this.wh),
      }, 0.5)

      .to(this.loader.logo, {
        opacity: 0,
        y: this.wh,
      }, 0.5);

    if (this.bio) return;

    tl
      .to(this.title, {
        y: 0,
        opacity: 1,
        clearProps: 'all',
      }, 1)

      .to(this.lines, {
        y: 0,
        stagger: 0.09,
        clearProps: 'all',
      }, 1);
  }

  addEvents = () => {
    window.addEventListener('resize', this.resetLoader);
  }

  init = () => {
    this.body.classList.add('is-loading');

    if (this.slides.el) {
      imagesLoaded(this.main, () => {
        this.setIntro();
        this.showIntro();
      });
    } else {
      imagesLoaded(this.main, () => {
        this.setLoader();
        this.showLoader();
      });
    }
    this.addEvents();
  }
}
